
import { Button } from '@/components/ui/button';

type AuthHeaderProps = {
  mode?: 'signin' | 'signup';
};

export const AuthHeader = ({ mode }: AuthHeaderProps) => {
  return (
    <>
      <div className="flex flex-col items-center mb-6 sm:mb-8">
        <div className="w-16 h-16 sm:w-20 sm:h-20 rounded-full bg-gradient-to-br from-blue-500/20 to-purple-500/20 flex items-center justify-center p-4 mb-4">
          <span className="font-inter font-bold text-3xl text-blue-400">AX</span>
        </div>
        <h1 className="text-xl sm:text-2xl font-bold text-white mb-2 text-center">Welcome to AnalystX</h1>
        <p className="text-gray-400 text-sm sm:text-base text-center">Your AI-powered market research assistant</p>
      </div>
    </>
  );
};
